import sdk, { type SalonStockerHttpTypes } from "@repo/api-sdk";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";

export function sellerListQuery(
  query?: SalonStockerHttpTypes.StoreSellerListParams
) {
  return queryOptions({
    queryKey: queryKeys.list(),
    queryFn: () => sdk.store.seller.list(query),
    staleTime: 5 * 60 * 1000
  });
}

export function useSellersMap(
  query?: SalonStockerHttpTypes.StoreSellerListParams,
  options?: {
    enabled?: boolean;
  }
) {
  return useQuery({
    ...sellerListQuery(query),
    select: ({ sellers }) => {
      return sellers.reduce(
        (acc, item) => {
          acc[item.id] = item;
          return acc;
        },
        {} as Record<string, SalonStockerHttpTypes.StoreSeller>
      );
    },
    ...options
  });
}
